<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="11"
    viewBox="0 0 15 11"
  >
    <g transform="translate(61 111)">
      <g transform="translate(-184.158 -276.364)">
        <g transform="translate(123.158 165.364)">
          <path
            d="M137.837,165.757a1.11,1.11,0,0,0-1.652-.047l-7.462,7.626-3.559-3.938a1.11,1.11,0,0,0-1.653-.024,1.33,1.33,0,0,0-.022,1.781l4.364,4.828a1.11,1.11,0,0,0,1.642.035l8.3-8.481A1.329,1.329,0,0,0,137.837,165.757Z"
            transform="translate(-123.158 -165.364)"
            :fill="fill || '#68b833'"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "apply-icon",
  props: ["fill"],
};
</script>
